import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'order',
    loadChildren: () => import('../../components/order/order.module').then(m => m.OrderModule),
    data: {
      breadcrumb: 'Order'
    }
  },
  {
    path: 'changePassword',
    loadChildren: () => import('../../components/change-password/change-password.module').then(m => m.ChangePasswordModule),
  },
  {
    path: 'finance',
    loadChildren: () => import('../../components/finance/finance.module').then(m => m.FinanceModule),
    data: {
      breadcrumb: 'Finance'
    }
  },
  {
    path: 'packing',
    loadChildren: () => import('../../components/packing/packing.module').then(m => m.PackingModule),
    data: {
      breadcrumb: 'Packing'
    }
  }
];
